var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 1C56.4348 1 62.8065 2.26742 68.7515 4.7299C74.6964 7.19238 80.0982 10.8017 84.6482 15.3518C89.1983 19.9018 92.8076 25.3036 95.2701 31.2485C97.7326 37.1935 99 43.5652 99 50C99 56.4348 97.7326 62.8065 95.2701 68.7515C92.8076 74.6965 89.1983 80.0982 84.6482 84.6482C80.0982 89.1983 74.6964 92.8076 68.7515 95.2701C62.8065 97.7326 56.4348 99 50 99C43.5652 99 37.1934 97.7326 31.2485 95.2701C25.3035 92.8076 19.9018 89.1983 15.3518 84.6482C10.8017 80.0981 7.19237 74.6964 4.72989 68.7515C2.26742 62.8065 0.999997 56.4347 1 50C1 43.5652 2.26743 37.1934 4.72991 31.2485C7.1924 25.3035 10.8017 19.9018 15.3518 15.3517C19.9019 10.8017 25.3036 7.19237 31.2485 4.72989C37.1935 2.26741 43.5653 0.999996 50 1L50 1Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 46.5L43.5 66L76 33.5",
    stroke: "url(#paint1_linear)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -3.27103,
    y1: 7.00935,
    x2: 100,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.128125,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508333,
    stopColor: "#00FFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 22.2991,
    y1: 35.778,
    x2: 53.9156,
    y2: 81.3287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.128125,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508333,
    stopColor: "#00FFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSuccess);
export default __webpack_public_path__ + "static/media/transaction-success.16d3f970.svg";
export { ForwardRef as ReactComponent };